export const sortTargetsByPercent = (b: Target, a: Target) => (a.logTotal || 0) / (a.value || 1) - (b.logTotal || 0) / (b.value || 1);
